/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Bench_Sidebar_TitleInputs */

const en_home_bench_sidebar_title = /** @type {(inputs: Home_Bench_Sidebar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work to hand over`)
};

const lv_home_bench_sidebar_title = /** @type {(inputs: Home_Bench_Sidebar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darbs, ko nodot`)
};

/**
* | output |
* | --- |
* | "Work to hand over" |
*
* @param {Home_Bench_Sidebar_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_bench_sidebar_title = /** @type {((inputs?: Home_Bench_Sidebar_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Bench_Sidebar_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_bench_sidebar_title(inputs)
	return en_home_bench_sidebar_title(inputs)
});